module.exports = __webpack_public_path__ + "static/media/img-day-of-week.45147f69.png";